<template>
  <SideBlock class="TableOfContents" :title="$t('toc.title')">
    <ul>
      <li v-for="(heading, index) in headings" :key="index">
        <a
          :href="`#${$helpers.stringToSlug(heading)}`"
          class="flex items-center gap-2"
        >
          <IconComponent icon="arrow-right" class="inline" />
          {{ heading }}
        </a>
      </li>
    </ul>
  </SideBlock>
</template>

<script>
import SideBlock from "~/components/_refactored/mainpage/SideBlock.vue";
export default {
  components: { SideBlock },
  props: {
    content: {
      type: String,
      required: true,
    },
  },
  computed: {
    headings() {
      if (!this.content) return [];

      let parser, doc;

      if (process.client) {
        // Client-side: use browser's DOMParser
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = this.content;
        return Array.from(tempDiv.querySelectorAll("h2")).map((h2) =>
          h2.textContent.trim()
        );
      } else {
        // Server-side: use linkedom
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const { DOMParser } = require("linkedom");
        parser = new DOMParser();
        doc = parser.parseFromString(this.content, "text/html");
        return Array.from(doc.querySelectorAll("h2")).map((h2) =>
          h2.textContent.trim()
        );
      }
    },
  },
};
</script>
